import React, { useState } from 'react';

import { isValidMobileNumber } from '@groww-tech-pvt/ella';
import { Button } from '@groww-tech-pvt/ui-toolkit';
import { GobblerNOFWebOnbApiError, GobblerNOFWebOnbCtaClick } from '@groww-tech-pvt/gobbler-proto-ts/dist';

import { sendLinkToMobile } from 'src/utils/services';
import { GENERAL_ERROR_CONSTANTS } from 'core/constants';
import { trackEvent } from 'src/utils/adapter/gobbler';
import InputField from 'src/components/InputField';

const MobileNumberInput = (props: MobileNumberInputProps) => {

  const { mobileNumber, setMobileNumber, onSuccess } = props;

  const [errorText, setErrorText] = useState('');
  const [isLoading, setIsLoading] = useState(false);


  const onMobileNumberChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const numberRegex = /^\d*$/;

    if (numberRegex.test(e.target.value)) {
      setErrorText('');
      setMobileNumber(e.target.value);
      if (mobileNumber?.length === 9) {
        trackEvent('GobblerNOFWebOnbCtaClick', GobblerNOFWebOnbCtaClick, { buttonText: 'SEND LINK', buttonAction: 'send_link' });
      }
    }
  };


  const onSendButtonClick = () => {
    trackEvent('GobblerNOFWebOnbCtaClick', GobblerNOFWebOnbCtaClick, { buttonText: 'SEND LINK', buttonAction: 'send_link' });

    if (!isValidMobileNumber(mobileNumber)) {
      setErrorText('Enter a valid mobile number');
      return;
    }

    setIsLoading(true);
    sendLinkToMobile(mobileNumber).then(() => {
      setIsLoading(false);
      onSuccess();
    }).catch(error => {
      trackEvent('GobblerNOFWebOnbApiError', GobblerNOFWebOnbApiError, { errorMessage: error?.response?.data?.errorMessage?.message ?? GENERAL_ERROR_CONSTANTS.GENERAL_ERROR });
      const errorStatusCode = error?.response?.status ?? 500;
      let errorMessage = GENERAL_ERROR_CONSTANTS.GENERAL_ERROR;

      if (errorStatusCode < 500) {
        errorMessage = error?.response?.data?.errorMessage?.message ?? GENERAL_ERROR_CONSTANTS.GENERAL_ERROR;
      }

      setIsLoading(false);
      setErrorText(errorMessage);
    });

  };


  return (<>
    <div className="width100 flex flex-col gap-2">
      <InputField
        value={mobileNumber}
        onChange={onMobileNumberChange}
        placeholder={'+91 9999988888'}
        maxLength={10}
        label='Get an SMS for app link'
      />
      <Button
        buttonText='SEND LINK'
        onClick={onSendButtonClick}
        isDisabled={mobileNumber?.length !== 10}
        isLoading={isLoading}
        isFullWidth={false}
        dataTestId='onboarding-app-download-send-sms'
      />

    </div>
    <div className={'adp901ErrorText bodyBase'}>{errorText}</div>
  </>);
};


type MobileNumberInputProps = {
  mobileNumber: string;
  setMobileNumber: React.Dispatch<React.SetStateAction<string>>;
  onSuccess: () => void;
}
export default MobileNumberInput;
